export default {"src":"/_next/static/media/Post-TraumaticArthritis.34f73dfe.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};